import React from "react";

import { H3 } from "./H3";

export function QuestionText({ Description }) {
  return <H3>{Description}</H3>;
}
